import { FiAlertCircle, FiShieldOff } from "react-icons/fi";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useTranslator from "../../hooks/useTranslator";
import { DownloadIcon } from "../../helper/svgHelper";
import {
  getInsuranceReviewTooltip,
  INSURANCE_REPORT_STATUS,
} from "../../Utils/insuranceReportStatus";

// Group insurability pill from the insurance simulation. Shared by the
// recommendation report (DecisionCard) and the DEA report (ReportOverview).
const InsurabilityBadge = ({
  status,
  errorCode,
  errorCodes = [],
  preFilledInsuranceDocument,
  contactOnly = false,
}) => {
  const { _t } = useTranslator();
  const resolvedStatus = contactOnly
    ? INSURANCE_REPORT_STATUS.UNDER_REVIEW
    : status;
  if (!resolvedStatus) return null;

  const isInsurable = resolvedStatus === INSURANCE_REPORT_STATUS.INSURABLE;
  const isUnderReview = resolvedStatus === INSURANCE_REPORT_STATUS.UNDER_REVIEW;
  const reviewTooltip = isUnderReview
    ? getInsuranceReviewTooltip({ errorCode, errorCodes, translate: _t })
    : null;

  return (
    <>
      <span
        data-tooltip-id={
          isUnderReview && !contactOnly
            ? "insurance-insurability-tooltip"
            : undefined
        }
        style={{
          color: isInsurable
            ? "#82CF3F"
            : isUnderReview
              ? "#737F7B"
              : "#FF3C3C",
          backgroundColor: isInsurable
            ? "#F2FBE9"
            : isUnderReview
              ? "#F3F4F4"
              : "#FFE2E2",
          border: isInsurable
            ? "none"
            : isUnderReview
              ? "1px solid #D9DEDC"
              : "1px solid #EB9B9C",
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          padding: "var(--space-2) var(--space-8)",
          borderRadius: "var(--radius-pill)",
          fontSize: "var(--text-12)",
          fontWeight: 600,
          lineHeight: "1rem",
          whiteSpace: "nowrap",
          cursor: isUnderReview && !contactOnly ? "help" : "default",
        }}
        className="report-overview__badge"
      >
        {isInsurable ? (
          <img src={"/images/shield.svg"} alt="" />
        ) : isUnderReview ? (
          <FiAlertCircle className="report-overview__badge-icon" size={14} />
        ) : (
          <FiShieldOff className="report-overview__badge-icon" size={14} />
        )}
        {isInsurable ? (
          _t("insurable")
        ) : isUnderReview ? (
          contactOnly ? (
            <>
              {_t("insurability", "Insurability")}:{" "}
              <a
                href="https://wa.me/34617662602"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => event.stopPropagation()}
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                {_t("contactUs", "Contact us")}
              </a>
            </>
          ) : (
            _t("insurabilityUnderReview", "Insurability under review")
          )
        ) : (
          _t("notInsurable")
        )}
        {isInsurable && preFilledInsuranceDocument && (
          <a
            href={`${preFilledInsuranceDocument}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="download-icon-wrapper"
            style={{ color: "inherit", lineHeight: 0 }}
          >
            <DownloadIcon />
          </a>
        )}
      </span>
      {isUnderReview && !contactOnly && (
        <ReactTooltip
          id="insurance-insurability-tooltip"
          place="bottom"
          noArrow
          className="react-tooltip-styling insurance-insurability-tooltip"
          render={() => (
            <div>
              {reviewTooltip.title && (
                <p className="insurance-insurability-tooltip-title">
                  <span>{reviewTooltip.title}</span>
                </p>
              )}
              <p>{reviewTooltip.description}</p>
            </div>
          )}
        />
      )}
    </>
  );
};

export default InsurabilityBadge;
